import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { Grid, GridItem, LoadingDots } from '@flos/react-ui';
import CheckoutAccordion from './components/CheckoutAccordion';
import CheckoutSidebar from './components/CheckoutSidebar';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { isOpcJobSelector } from '../../recoil/selectors/isOpcJobSelector';
import { checkoutProgressSelector } from '../../recoil/selectors/checkoutProgressSelector';

const CheckoutPage: WizardPageComponent = () => {
    const { wizardNextStep, wizardPreviousStep } = useWizardNavigation();
    const getHippoText = useHippoText();
    const isOpcJob = useRecoilValue(isOpcJobSelector);
    const checkoutProgress = useRecoilValue(checkoutProgressSelector);

    if (checkoutProgress.totalSteps === 0) {
        return <LoadingDots />;
    }

    return (
        <>
            <WizardPagetemplate
                onNext={wizardNextStep}
                onPrevious={wizardPreviousStep}
                hideNext
                hidePrevious
                showGiftCertificateBanner={false}
            >
                <Grid className={'u-shadow-none'}>
                    {!isOpcJob && (
                        <GridItem span={12}>
                            <h3>{getHippoText('DSS-CHECKOUT-HEADER')}</h3>
                        </GridItem>
                    )}
                    <GridItem span={7}>
                        <CheckoutAccordion wizardNextStep={wizardNextStep} />
                    </GridItem>
                    <GridItem colStart={9} span={4}>
                        <CheckoutSidebar />
                    </GridItem>
                </Grid>
            </WizardPagetemplate>
        </>
    );
};

export default CheckoutPage;
